import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const avatarSize = '30px'

const GroupListItemRow = ({
   borderColor,
   members,
   name,
   numMembers,
   linkTo,
   privacy,
   textColor
}) => (
   <Link to={linkTo}>
      <View
         display="flex"
         justifyContent="space-between"
         alignItems="flex-start[a-b] center[c-f]"
         flexFlow="row"
         height="50px[c-f]"
         padding="15px 0px[a-b]"
         borderBottom={`1px solid ${borderColor}`}>
         <View
            display="flex"
            flexFlow="column[a-b] row[c-f]"
            flex="1 1 auto"
            opacity="0.8">
            <View paddingRight="10px">
               <Text size="2.5" color={textColor} weight="medium">
                  {name}
               </Text>
            </View>
            {['admin', 'draft', 'private'].includes(privacy) && (
               <View display="flex" flex="0 0 auto" paddingRight="10px" opacity="0.5">
                  <Text size="1.5" color={textColor} transform="capitalize">
                     {privacy !== 'admin' && privacy}
                     {privacy === 'admin' && 'Admin-only'}
                  </Text>
                  {numMembers > 1 && (
                     <View display="block[a-b] none[c-f]" padding="0px 5px">
                        <Text size="1.5" color={textColor}>—</Text>
                     </View>
                  )}
               </View>
            )}
            <View flex="0 0 auto" opacity="0.5">
               <Text size="1.5" color={textColor}>
                  {numMembers > 1 && `${numMembers} Members`}
               </Text>
            </View>
         </View>
         <View
            flex="0 0 auto"
            width="180px[c-f]"
            display="flex"
            justifyContent="flex-start[a-b] flex-end[c-f]"
            alignItems="center"
            paddingLeft="20px">
            {members.map(user => (
               <View
                  key={user.id}
                  float="left"
                  height={avatarSize}>
                  <View
                     display="flex"
                     justifyContent="center"
                     alignItems="center"
                     float="left"
                     flex="0 0 auto"
                     width={avatarSize}
                     height={avatarSize}
                     borderRadius="50%"
                     marginRight="-4px"
                     border="2px solid #fff"
                     backgroundColor="#eee"
                     backgroundImage={user.avatarMedia
                        ? `url(${user.avatarMedia.file.thumbnailUrlW48})`
                        : '/assets/images/avatarPlaceholder.svg'
                     }
                     backgroundSize={user.avatarMedia ? 'cover' : '30px 30px'}
                     backgroundPosition="bottom center"
                     style={{ backgroundRepeat: 'no-repeat' }}>
                     {!user.avatarMedia && (
                        <Text
                           size="0.9"
                           color="#888"
                           weight="medium"
                           transform="uppercase">
                           {`${user.firstName.charAt(0)}${user.lastName.charAt(0)}`}
                        </Text>
                     )}
                  </View>
               </View>
            ))}
         </View>
      </View>
   </Link>
)

GroupListItemRow.propTypes = {
   borderColor: PropTypes.string.isRequired,
   members: PropTypes.array,
   name: PropTypes.string.isRequired,
   numMembers: PropTypes.number.isRequired,
   linkTo: PropTypes.string.isRequired,
   privacy: PropTypes.string.isRequired,
   textColor: PropTypes.string.isRequired
}

GroupListItemRow.defaultProps = {
   members: []
}

export default GroupListItemRow
